import { getScaledValue, getMaxValue, getMinValue } from '@/helpers/helpers'
import { getEvClr, getEqClr, eqrClr } from '@/helpers/solution'

function getRepPlayers({ players, isTurn, totals, relativeHeroPosition, hSpot }) {
  const playerOne = players.find(p => (isTurn ? !p.is_hero : !p.is_folded && p.is_active))
  const playerTwo = players.find(p => (isTurn ? p.is_hero : !p.is_folded && !p.is_active))

  const opponentPos = relativeHeroPosition === 'ip' ? 'oop' : 'ip'

  const playerOnePos = isTurn
    ? playerOne.relative_position.toLowerCase()
    : hSpot.position === playerOne?.position
      ? relativeHeroPosition
      : opponentPos
  const playerTwoPos = isTurn
    ? playerTwo.relative_position.toLowerCase()
    : hSpot.position === playerTwo?.position
      ? relativeHeroPosition
      : opponentPos

  const l_players = [
    {
      ...playerOne,
      is_hero: !!(playerOne.is_hero || playerOne?.is_active),
      relative_position: playerOnePos,
      position: playerOne.position,
      total_ev: totals[`${playerOnePos}_ev`],
      total_eq: totals[`${playerOnePos}_eq`],
      total_eqr: totals[`${playerOnePos}_eqr`],
    },
    {
      ...playerTwo,
      is_hero: !!(playerTwo.is_hero || playerTwo?.is_active),
      relative_position: playerTwoPos,
      position: playerTwo.position,
      total_ev: totals[`${playerTwoPos}_ev`],
      total_eq: totals[`${playerTwoPos}_eq`],
      total_eqr: totals[`${playerTwoPos}_eqr`],
    },
  ]
  const ipPlayer = l_players.find(p => p.relative_position === 'ip')
  const oopPlayer = l_players.find(p => p.relative_position === 'oop')
  // }
  const hero = l_players.find(p => p.is_hero)
  const opponent = l_players.find(p => !p.is_hero)
  const res = { hero, opponent, ipPlayer, oopPlayer }
  // console.log(res)
  // debugger
  return res
}

function getRepStrategyClrs({ actions }) {
  let totalFreq = actions.reduce((a, b) => a + (b.frequency || 0), 0)
  totalFreq = totalFreq > 1 ? 1 : totalFreq

  const nrmIncrement = 1 / totalFreq

  // order of X >> RAI
  // const res = actions.reduce(
  // order of  RAI >> X
  const res = actions.reduceRight(
    (a, b, index) => {
      if (b.frequency) {
        const clr = b.css_class
        const { hex } = b
        const p = a.p + b.frequency * nrmIncrement * 100
        // console.log(index, b)
        return {
          clrs_var: `${a.clrs_var}linear-gradient(to right, var(--clr-${clr}), var(--clr-${clr})),`,
          clrs_hex: `${a.clrs_hex}linear-gradient(to right, ${hex}, ${hex}),`,
          size: `${a.size} 100% ${p}%,`,
          size_horizontal: `${a.size_horizontal}${p}% 100%,`, // same as size in getStrategyClrs from solution.js
          p,
        }
      }
      return a
    },
    {
      clrs_var: '',
      clrs_hex: '',
      size: '',
      size_horizontal: '',
      p: 0,
    },
  )

  res.clrs_var = res.clrs_var.slice(0, -1)
  res.clrs_hex = res.clrs_hex.slice(0, -1)
  res.size = res.size.slice(0, -1)
  res.size_horizontal = res.size_horizontal.slice(0, -1)
  // let strategy_var = `background:red`
  const strategy_var = `background-image: ${res.clrs_var}; background-size:${res.size};height:${
    totalFreq * 100
  }%`
  const strategy_hex = `background-image: ${res.clrs_hex}; background-size:${res.size};height:${
    totalFreq * 100
  }%`
  const strategy_horizontal_var = `background-image: ${res.clrs_var}; background-size:${res.size_horizontal}; height: 100%;`
  const strategy_horizontal_hex = `background-image: ${res.clrs_hex}; background-size:${res.size_horizontal}; height: 100%;`
  return {
    strategy_var,
    strategy_hex,
    strategy_horizontal_var,
    strategy_horizontal_hex,
  }
}

function getRepStyle({
  ip_total_ev,
  ip_ev,
  ip_eq,
  ip_eqr,
  oop_total_ev,
  oop_ev,
  oop_eq,
  oop_eqr,
  ip_ev_normalized,
  ip_eq_normalized,
  ip_eqr_normalized,
  oop_ev_normalized,
  oop_eq_normalized,
  oop_eqr_normalized,
  actions,
}) {
  const { strategy_var, strategy_hex, strategy_horizontal_var, strategy_horizontal_hex } =
    getRepStrategyClrs({ actions })
  // let { clrs_var, clrs_hex, size, size_vertical } = getStrategyClrs({ solution: actions, range: 1 })
  // let strategy_var = `background-image: ${clrs_var}; background-size:${size_vertical};`
  // let strategy_hex = `background-image: ${clrs_hex}; background-size:${size_vertical};`
  // debugger

  const ip_evClr = getEvClr({ total_ev: ip_total_ev, ev: ip_ev, clrScale: 50 })
  const ip_eqClr = getEqClr({ eq: ip_eq, clrScale: 25 })
  const ip_eqrClr = eqrClr({ eqr: ip_eqr, clrScale: 25 })
  const ip = {
    ev_style: `background: var(${ip_evClr}); height: ${ip_ev_normalized * 100}%`,
    eq_style: `background: var(${ip_eqClr}); height: ${ip_eq_normalized * 100}%`,
    eqr_style: `background: var(${ip_eqrClr}); height: ${ip_eqr_normalized * 100}%`,
    evClr: ip_evClr,
    eqClr: ip_eqClr,
    eqrClr: ip_eqrClr,
    ev_normalized: ip_ev_normalized,
    eq_normalized: ip_eq_normalized,
    eqr_normalized: ip_eqr_normalized,
    htc_range: 1,
  }
  const oop_evClr = getEvClr({ total_ev: oop_total_ev, ev: oop_ev, clrScale: 50 })
  const oop_eqClr = getEqClr({ eq: oop_eq, clrScale: 25 })
  const oop_eqrClr = eqrClr({ eqr: oop_eqr, clrScale: 25 })

  const oop = {
    ev_style: `background: var(${oop_evClr}); height: ${oop_ev_normalized * 100}%`,
    eq_style: `background: var(${oop_eqClr}); height: ${oop_eq_normalized * 100}%`,
    eqr_style: `background: var(${oop_eqrClr}); height: ${oop_eqr_normalized * 100}%`,
    evClr: oop_evClr,
    eqClr: oop_eqClr,
    eqrClr: oop_eqrClr,
    ev_normalized: oop_ev_normalized,
    eq_normalized: oop_eq_normalized,
    eqr_normalized: oop_eqr_normalized,
    htc_range: 1,
  }

  const res = {
    strategy_var,
    strategy_hex,
    strategy_horizontal_var,
    strategy_horizontal_hex,
    ip,
    oop,
  }
  // console.log(res)
  return res
}

function getRepItems({
  repApiData,
  totals,
  // isTurn,
  available_actions,
  idKey,
  ipPlayer,
  oopPlayer,
  flopGroup,
}) {
  const ip_maxEv = getMaxValue({ arr: repApiData, key: 'ip_ev' })
  const ip_minEv = getMinValue({ arr: repApiData, key: 'ip_ev' })
  const oop_maxEv = getMaxValue({ arr: repApiData, key: 'oop_ev' })
  const oop_minEv = getMinValue({ arr: repApiData, key: 'oop_ev' })
  const ip_maxEq = getMaxValue({ arr: repApiData, key: 'ip_eq' })
  const ip_minEq = getMinValue({ arr: repApiData, key: 'ip_eq' })
  const oop_maxEq = getMaxValue({ arr: repApiData, key: 'oop_eq' })
  const oop_minEq = getMinValue({ arr: repApiData, key: 'oop_eq' })
  const ip_maxEqr = getMaxValue({ arr: repApiData, key: 'ip_eqr' })
  const ip_minEqr = getMinValue({ arr: repApiData, key: 'ip_eqr' })
  const oop_maxEqr = getMaxValue({ arr: repApiData, key: 'oop_eqr' })
  const oop_minEqr = getMinValue({ arr: repApiData, key: 'oop_eqr' })

  const ip_total_ev = getScaledValue({
    min: ip_minEv,
    max: ip_maxEv,
    value: totals.ip_ev,
  })
  const oop_total_ev = getScaledValue({
    min: oop_minEv,
    max: oop_maxEv,
    value: totals.oop_ev,
  })

  const items = repApiData.map((i, idx) => {
    const actions = available_actions.map(a => {
      const freq = i.actions || i.solutions ? (i.actions || i.solutions)[a.order]?.frequency : 0
      return {
        ...a,
        frequency: freq,
        strategy: freq,
        isNa: freq === null,
      }
    })

    const style = getRepStyle({
      ip_total_ev,
      ip_ev: getScaledValue({ min: ip_minEv, max: ip_maxEv, value: i.ip_ev }),
      ip_eq: getScaledValue({ min: ip_minEq, max: ip_maxEq, value: i.ip_eq }),
      ip_eqr: getScaledValue({ min: ip_minEqr, max: ip_maxEqr, value: i.ip_eqr }),

      oop_total_ev,
      oop_ev: getScaledValue({ min: oop_minEv, max: oop_maxEv, value: i.oop_ev }),
      oop_eq: getScaledValue({ min: oop_minEq, max: oop_maxEq, value: i.oop_eq }),
      oop_eqr: getScaledValue({ min: oop_minEqr, max: oop_maxEqr, value: i.oop_eqr }),

      ip_ev_normalized: i.ip_ev / ip_maxEv,
      ip_eq_normalized: i.ip_eq / ip_maxEq,
      ip_eqr_normalized: i.ip_eqr / ip_maxEqr,
      oop_ev_normalized: i.oop_ev / oop_maxEv,
      oop_eq_normalized: i.oop_eq / oop_maxEq,
      oop_eqr_normalized: i.oop_eqr / oop_maxEqr,
      actions,
    })

    const r = {
      data_idx: i.data_idx ?? idx,
      ...i,
      ip: {
        no_data: (i.ip_ev ?? null) === null,
        ev: i.ip_ev,
        eq: i.ip_eq,
        eqr: i.ip_eqr,
        ...style.ip,
      },
      oop: {
        no_data: (i.oop_ev ?? null) === null,
        ev: i.oop_ev ?? null,
        eq: i.oop_eq ?? null,
        eqr: i.oop_eqr ?? null,
        ...style.oop,
      },
      backgrounds: {
        hex: style.strategy_hex,
        var: style.strategy_var,
        horizontal_hex: style.strategy_horizontal_hex,
        horizontal_var: style.strategy_horizontal_var,
      },
      id: i[idKey],
      // display_name:
      // reportsStreetGrouping === 'flops' ? i[idKey] :
      // reportsStreetGrouping === 'suits'?'suitshtml':
      // i18n.global.t(`practice.filter.${i.group}`),
      actions,
      solution: actions,
      flopGroup,
      // htc_range: 1,
    }
    return r
  })
  // console.log(res)
  // console.log(ipPlayer)
  // ipPlayer
  // oopPlayer
  const res = {
    items,
    eveqeqrAxes: {
      ip_ev: ipPlayer.total_ev,
      ip_eq: ipPlayer.total_eq,
      ip_eqr: ipPlayer.total_eqr,
      oop_ev: oopPlayer.total_ev,
      oop_eq: oopPlayer.total_eq,
      oop_eqr: oopPlayer.total_eqr,
      ip_ev_normalized: ipPlayer.total_ev / ip_maxEv,
      ip_eq_normalized: ipPlayer.total_eq / ip_maxEq,
      ip_eqr_normalized: ipPlayer.total_eqr / ip_maxEqr,
      oop_ev_normalized: oopPlayer.total_ev / oop_maxEv,
      oop_eq_normalized: oopPlayer.total_eq / oop_maxEq,
      oop_eqr_normalized: oopPlayer.total_eqr / oop_maxEqr,
      // min: {
      //     ev: Math.min(ip_minEv, oop_minEv),
      //     eq: Math.min(ip_minEq, oop_minEq),
      //     eqr: Math.min(ip_minEqr, oop_minEqr),
      // },
      // max: {
      //     ev: Math.max(ip_maxEv, oop_maxEv),
      //     eq: Math.max(ip_maxEq, oop_maxEq),
      //     eqr: Math.max(ip_maxEqr, oop_maxEqr),
      // },
      // ip_maxEv,
      // ip_minEv,
      // oop_maxEv,
      // oop_minEv,
      // ip_maxEq,
      // ip_minEq,
      // oop_maxEq,
      // oop_minEq,
      // ip_maxEqr,
      // ip_minEqr,
      // oop_maxEqr,
      // oop_minEqr,
    },
  }
  return res
}

function getRepItemsActionsFiltered({ repItems, available_actions }) {
  const res = repItems.map((i, idx) => {
    const actions = available_actions.map(a => {
      const freq = i.actions[a.order_reverse]?.frequency || 0
      return {
        ...a,
        frequency: freq,
        strategy: freq,
      }
    })
    const { strategy_var, strategy_hex, strategy_horizontal_var, strategy_horizontal_hex } =
      getRepStrategyClrs({ actions })
    // let { clrs_var, clrs_hex, size } = getStrategyClrs({ solution: actions, range: 1 })
    // let strategy_var = `background-image: ${clrs_var}; background-size:${size};`
    // let strategy_hex = `background-image: ${clrs_hex}; background-size:${size};`
    const r = {
      ...i,
      backgrounds: {
        hex: strategy_hex,
        var: strategy_var,
        horizontal_hex: strategy_horizontal_hex,
        horizontal_var: strategy_horizontal_var,
      },
      actions,
      // solution: actions,
    }
    return r
  })
  return res
}

export { getRepPlayers, getRepStyle, getRepItems, getRepItemsActionsFiltered }
